import React, { useState, useEffect } from "react";
import "./subscription.css";
import moment from "moment/moment";
import _ from "lodash";

const Subscription = ({ activeSubscription }) => {
  const hasSubscription = _.get(activeSubscription, "subscriptionDisplayValue");

  const subscriptionPeriod = "/ month billed monthly";
  const planDetails = `${_.get(activeSubscription, "subscriptionDisplayValue")} (Remaining)`;

  const [remainingDays, setRemainingDays] = useState(_.get(activeSubscription, "remainingDays", 0));

  useEffect(() => {
    setRemainingDays(_.get(activeSubscription, "remainingDays", 0));
  }, [activeSubscription]);

  if (!hasSubscription) {
    return (
      <div className="subscription-card">
        <div className="subscription-header">
          <h3>Subscription</h3>
        </div>
        <div className="subscription-details">
          <p className="no-subscription-msg">No active subscription</p>
        </div>
        {/* <div className="subscription-actions">
          <button className="upgrade-plan">Upgrade Plan</button>
          <button className="renew">Renew</button>
        </div> */}
      </div>
    );
  }

  const activationDate = moment(_.get(activeSubscription, "activationDate"));
  const expiryDate = moment(_.get(activeSubscription, "expiryDate"));
  const totalDays = expiryDate.diff(activationDate, "days");

  const progressWidth = `${Math.min((remainingDays / totalDays) * 100, 100)}%`;

  const priceMapping = {
    "Essential": 20000,
    "Essential+": 30000,
    "Elite": 45000
  };

  const subscriptionType = _.get(activeSubscription, "subscriptionDisplayValue", ' ');
  const price = priceMapping[subscriptionType];

  const isFreeTrial =
    subscriptionType.toLowerCase().includes("free") ||
    subscriptionType.toLowerCase().includes("trial");

  return (
    <div className="subscription-card">
      <div className="subscription-header">
        <h3>Subscription</h3>
        {!isFreeTrial && (
          <div className="subscription-amount">
            {/* <span className="amount">₹ {price}</span>
            <span className="period">{subscriptionPeriod}</span> */}
            <span className="period">{subscriptionType}</span>
          </div>
        )}
      </div>
      <div className="subscription-details">
        <div className="subscription-plan">{planDetails}</div>
        <div className="subscription-bar-container">
          <div className="subscription-bar" style={{ width: progressWidth }}></div>
        </div>
        <div className="subscription-time">
          <span className="remaining-date">{remainingDays} Days Remaining</span>
          <span className="expiry-date">
            Expires On <strong>{expiryDate.format("DD MMM, YYYY")}</strong>
          </span>
        </div>
      </div>
      {/* <div className="subscription-actions">
        <button className="upgrade-plan">Upgrade Plan</button>
        <button className="renew">Renew</button>
      </div> */}
    </div>
  );
};

export default Subscription;